import type { TableProps } from 'antd';
import { Space, Table } from 'antd';
import React from 'react';
import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  padding: 24px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const PageTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: #1a1a1a;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const Toolbar = styled(Space)`
  margin-bottom: 20px;
  flex-shrink: 0;
  width: 100%;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow: auto;
  min-height: 0;
`;

export const FormPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow-x: hidden;
`;

export const FormCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  padding: 28px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const FormPageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;

  h2 {
    font-size: 22px;
    font-weight: 700;
    margin: 0;
    color: #1a1a1a;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 18px;
    }
  }
`;

const BaseTable = styled(Table)`
  .ant-table-thead > tr > th {
    font-size: 12px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 700;
  }
  .ant-table-sticky-holder {
    z-index: 1 !important;
  }
  .ant-table-tbody > tr > td {
    padding: 15px;
    font-size: 14px;
  }
  .ant-table-row-expand-icon {
    border: none !important;
    background: transparent !important;
    color: #ff8e8e !important;
    box-shadow: none !important;
    &::before {
      height: 2.5px !important;
    }
    &::after {
      width: 2.5px !important;
    }

    &:hover {
      color: #ff6b6b !important;
      background: rgba(255, 142, 142, 0.1) !important;
      border-radius: 4px !important;
    }
  }
` as typeof Table;

export function StyledTable<T extends object>(props: TableProps<T>) {
  return <BaseTable sticky {...props} />;
}

StyledTable.Summary = (BaseTable as unknown as typeof Table).Summary;
